export const GET_HOLDING_ACCOUNTS = "GET_HOLDING_ACCOUNTS";
